import { Button, TextField } from "@mui/material";
import { useSVG } from "../SVGContext";
import { useEffect, useState } from "react";

export function ArrangeBtn({}) {
  const { setLeftPanel } = useSVG();
  return (
    <Button
      variant="outlined"
      size="small"
      onClick={() => {
        setLeftPanel("align");
      }}
    >
      Arrange
    </Button>
  );
}
